var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeachertraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "url(#pattern0_109_9466)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_109_9466",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_109_9466",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_109_9466",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADPElEQVR4nO3czW8NURjH8WOjGywQUTYoscBavFRQEWztrVhLW1ZiSyxtaLHgL7BDlLKwa2JBUjZsJI3US3K1UfH2lcNImumcuXPnPuecuTPPZ9ub53nml5OZudM51xillFJKKaWUUkoppZRSRQGHgBvAK2Ce5plPjn0cOCi+coAB4HHso6ygCWCzVMh7gY+xj6jCPgB7ug15EzAb+0h6gF2IA90E/Sj2EfSQybIhH449eQ/q/AKZ3F1kWQCGgfWmYYB+YCTJIMtYmaKvHcWGTcMBo45spssUm3MUa9xKTrMZOLL5YjrlKETHhWoKqXw06HwadCAadCAadCAadCA9HzSwE5gCWsBtYLWpoDoEPZVq+c4+DjAVU4egf2a0/QVcAZabiqhD0Hle2FOLqQDXgPEKCfVd5Ctw1vccZeeMV0iob4a7wBrf83Q6Z7xCQn0d3gPHfc/UyZzxCgn1zfEbuAr0+Z6tyJzxCgn1LeAlsMv3fO3mjFdIqG9Bfy+UwLJYc8YrJNS3Q/ZCuTbGnPEKCfUtwV4oT4SeM14hob4l2W+ZJ0POGa+QUN8uzIScM14hob5d0KCzIOsHcMp44GoYr5BQ34I+2Vezki8wp+27g6HnjFdIqG8bF4GNvmcrMme8QkJ923joe66ic8YrJNS3gEHfsxWZM14hob6JZzkvxU/4nq3InPEKCfUF3gLrgAtVWNV1Dbr1/19YwIqcXQjBztV1CHo+1fI7MJT6TN6q3ud7xroEfSf1UP9MxmdW5Zyrg6zqOgTdB5wHbgHHcj6Xt6p3B5izt4Muqs2qvmw8a0zQbVb1JeNZ04JeCbzJeJC0I0Dv5gRtAduBB8kt4HPgqAmgcUHHokEHokH3YNC6z9AB2ODIuWUEd86OmIYDzknunL3uKLaQ7IfuN83cCz4KfHNkc61M0f2u85ASfqAF3HfXVCn3SoW8aHP5TLqiWmK27T+Hc+4ulJxW3t2FkjNtg74pWFBlG7NBH3H8Ucn5tyE1eY1K+fF08QVxS/JDeUqWfRdwa/ru4wDwWbhR00MedN3qbQOexJ6wBiaXrGRH4EPJL8pO6312IXNJVuNV/CUGpZRSSimllFJKKSPsD978h1+NXTV1AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeachertraining);
export default __webpack_public_path__ + "static/media/Teacher training.32aacb9af765fa775e6706e15f0993fe.svg";
export { ForwardRef as ReactComponent };